import React,{Component} from 'react';
import AutoComplete from '../autocomplete/AutoComplete.js';

const APIHOST = process.env.REACT_APP_APIHOST;
const PUBLIC_URL = process.env.PUBLIC_URL;
const GEOCODER_URL=process.env.REACT_APP_MAPBOX_HOST
const GEOCODER_TOKEN=process.env.REACT_APP_MAPBOX_TOKEN
// process.env.REACT_APP_MAPBOX_TOKEN interpolates to the string "undefined"
// (not empty) when the var isn't set at all.
export const HAS_MAPBOX_TOKEN = !!GEOCODER_TOKEN && GEOCODER_TOKEN !== "undefined"

// Nominatim -- OpenStreetMap's free, keyless geocoder -- as a fallback when
// no Mapbox token is configured, so address search still works instead of
// sending unauthenticated requests to Mapbox. Meant for light use; see
// https://operations.osmfoundation.org/policies/nominatim/.
const NOMINATIM_URL = "https://nominatim.openstreetmap.org/search"

export class Geocoder extends Component{

    state={
        "clearButton":false
    }

    parser = (data) => {
        if (HAS_MAPBOX_TOKEN) {
            return data.features ? data.features : [];
        }
        // Nominatim's format=json returns a bare array shaped differently
        // than Mapbox's response -- normalize to the same {place_name,
        // center} shape onSelect/setGeocoderMarker already expect, so
        // nothing downstream needs to know which provider answered.
        if (!Array.isArray(data)) return [];
        return data.map((item) => ({
            place_name: item.display_name,
            center: [parseFloat(item.lon), parseFloat(item.lat)],
        }));
    }

    onSelect=(e)=>{
        this.props.setGeocoderMarker(e);
        this.props.setView(e.center,15);
        this.setState({"clearButton":true});
    }

    onClear=()=>{
        this.props.clearGeocoderMarker();
        this.setState({"clearButton":false});
        this.geocoderAutocomplete.clear();    
    }
    

    render(){
        let geocoderUrl = HAS_MAPBOX_TOKEN
            ? `${GEOCODER_URL}/{query}.json?country=us&access_token=${GEOCODER_TOKEN}`
            : `${NOMINATIM_URL}?format=json&countrycodes=us&q={query}`;

        return(
            <div className="Geocoder">
                <div style={{"height":"7px"}} />
                <AutoComplete 
                    ref = { (el) => { this.geocoderAutocomplete = el } }
                    apiParser={ this.parser }
                    caseSensitive={ false }
                    displayKey={ 'place_name' }
                    onSelect={ this.onSelect }
                    placeholder={ 'Find an address or city' }
                    url={ geocoderUrl }
                    inputStyle={{
                        "fontSize":"11px",
                        "height":"24px"
                    }}
                />
                {(this.state.clearButton)?(
                    <div className="ClearGeocode" onClick={this.onClear} title="Clear Location">
                        <img src={`${PUBLIC_URL}/close-grey.png`} style={{"height":"15px"}}/>
                    </div>
                    ):null
                }
            </div>
        );
    }
}